import React from "react";
import { Row, Col, Alert, Button } from "react-bootstrap";
import CourseSearch from "./CourseSearch";
import CoursePrice from "./CoursePrice";
import CourseTag from "./CourseTag";
import CourseCategory from "./CourseCategory";

const CourseSidebar = ({
  onSearch,
  loading,
  totalResults,
  currentSearch,
  selectedCategories = [],
  selectedPrice = "",
  selectedTags = [],
  onToggleCategory = () => {},
  onTogglePrice = () => {},
  onToggleTag = () => {},
  onClearFilters = () => {},
  filtersLoading = false,
  filtersError = "",
  categories = [],
  priceBuckets = [],
  tags = [],
}) => {
  const hasActiveFilters =
    selectedCategories.length > 0 ||
    Boolean(selectedPrice) ||
    selectedTags.length > 0;

  return (
    <div className="course-sidebar">
      <Row>
        <Col md="12">
          <CourseSearch
            onSearch={onSearch}
            loading={loading}
            totalResults={totalResults}
            currentSearch={currentSearch}
          />
        </Col>
        {filtersError && (
          <Col md="12">
            <Alert variant="warning" className="mt-3">
              {filtersError}
            </Alert>
          </Col>
        )}
        {hasActiveFilters && typeof onClearFilters === "function" && (
          <Col md="12" className="mb-3">
            <Button variant="link" className="p-0" onClick={onClearFilters}>
              Clear filters
            </Button>
          </Col>
        )}
        <Col md="12">
          <CourseCategory
            loading={filtersLoading}
            categories={categories}
            selectedCategories={selectedCategories}
            onToggleCategory={onToggleCategory}
          />
        </Col>
        <Col md="12">
          <CoursePrice
            loading={filtersLoading}
            priceBuckets={priceBuckets}
            selectedPrice={selectedPrice}
            onTogglePrice={onTogglePrice}
          />
        </Col>
        <Col md="12" style={{ marginTop: "2rem" }}>
          <CourseTag
            loading={filtersLoading}
            tags={tags}
            selectedTags={selectedTags}
            onToggleTag={onToggleTag}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CourseSidebar;
